import React, { useEffect, useState } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import DetailPageHeader from '../../pages/markets/component/detail-page-header';
import MarketNewsExternalWidget from '../../pages/markets/component/market-news-external-widget';
import SectoralIndicesExternalWidget from '../../pages/markets/component/sectoral-indices-external-widget';
import { useSelector } from "react-redux";
import get from "lodash/get";
import '../../pages/markets/pages/sectoral-indices-external/sectoral-indices-external.m.css';

const SectoralIndicesFull = ({ widget = false }) => {
  const queryClient = new QueryClient();
  const [initialLoading, setInitialLoading] = useState(true);
  const [marketNews, setMarketNews] = useState([]);
  const NDTV_SEARCH_API_CONFIG = useSelector((state) =>
    get(state, ['qt', 'config', 'integrations', 'aiSummary'], {}),
  );

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    body.style.overscrollBehaviorY = 'auto';

    const style = document.createElement('style');
    style.innerHTML = `
      body::-webkit-scrollbar {
        background-color: transparent;
      }
    `;
    document.head.appendChild(style);
  }, []);

  useEffect(() => {
    const getMarketNews = async () => {
      const response = await fetch(`${NDTV_SEARCH_API_CONFIG?.url}${NDTV_SEARCH_API_CONFIG?.client_key}${NDTV_SEARCH_API_CONFIG?.story_params}&pagesize=15&${NDTV_SEARCH_API_CONFIG?.markets_param}`);
      const data = await response;
      const dataInJson = await data.json();
      setMarketNews(dataInJson?.results || []);
    };
    getMarketNews();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <>
        {initialLoading ? (
          <div styleName="initial-loading-container"></div>
        ) : (
          <div styleName="detail-header-container">
            <div className="container">
              <DetailPageHeader widget={widget} />
            </div>
          </div>
        )}

        <div styleName="overall-container">
          <div className="container">
            <SectoralIndicesExternalWidget widget={widget} />
          </div>
        </div>
        <div className="container">
          <div styleName="market-video-container">
            <MarketNewsExternalWidget
              collection={marketNews}
              sectionTitle={'MARKETS NEWS'}
              widget={true}
            />
          </div>
        </div>
      </>
    </QueryClientProvider>
  );
};

export default SectoralIndicesFull;
